module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gb-nir-d60ecd946d5a8e91e615012bfca091e3.svg";